import * as React from "react";
import { IServiceStatus } from "@nju/data-access-portal-product";

export const ServiceStatusContext = React.createContext<IServiceStatus>({
  ftthServiceStatus: undefined,
  mobileServiceStatus: undefined,
  fSecureServiceStatus: undefined,
});

export function useServiceStatus() {
  const value = React.useContext(ServiceStatusContext);

  if (value === null) {
    throw new Error("`Missing ServiceStatusContext` in tree.");
  }

  return value;
}
